import React, { useState } from "react";
import ModalPopup from "./Modal";

const SubdomainModal = ({
    modalOpen,
    setModalOpen,
    onSubmit,
    subdomainError,
    title,
    message,
}) => {
    console.log('modalOpen: ', modalOpen);
    const [subdomain, setSubdomain] = useState("");

    const closeModal = () => {
        setModalOpen(false);
        setSubdomain("");
    };

    const handleSubmit = () => {
        if (subdomain.trim()) {
            onSubmit(subdomain);
            closeModal();
        }
    };

    return (
        <ModalPopup
            className="alert-box-popup"
            show={modalOpen}
            size="md"
            onHide={closeModal}
        >
            <div className="text-center flex justify-center flex-col items-center gap-3 px-3">
                <h3>{title || "Enter Subdomain"}</h3>
                <p className="text-card-body">
                    {message || "Please enter the subdomain below."}
                </p>
                
                <input
                    type="text"
                    name="subdomain"
                    value={subdomain}
                    className="mt-1 w-full border-2 border-gray-400 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                    placeholder="Please Enter Subdomain"
                    onChange={(e) => setSubdomain(e.target.value)}
                    style={{ color: "#111", background: "#fff" }} // input text color
                />
                {subdomainError && <div className="text-red-500 ">{subdomainError}</div>}
                {/* <input
                    type="text"
                    className="input-field"
                    placeholder="Subdomain"
                    value={subdomain}
                    onChange={(e) => setSubdomain(e.target.value)}
                /> */}
                <div className="w-full flex justify-between gap-3 mb-2">
                    <button className="button-field-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button
                        className="button-field-primary"
                        onClick={handleSubmit}
                        disabled={!subdomain.trim()}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </ModalPopup>
    );
};

export default SubdomainModal;